<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="form">
        <div class="search">
          <a-form layout="horizontal" :model="form">
            <a-row>
              <a-col :md="1" :sm="24"></a-col>
              <a-col :md="6" :sm="24">
                <a-form-item
                  label="发货地名称"
                  :labelCol="{ span: 8 }"
                  :wrapperCol="{ span: 15 }"
                >
                  <a-input placeholder="请输入" v-model.trim="form.name"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="search(1)">查询</a-button>
                <div class="space"></div>
                <a-button type="default" @click="reset()">重置</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>
      <div>
        <div class="tj">
          <a-button type="primary" @click="handleSendSave">
            <a-icon type="plus" />
            添加
          </a-button>
        </div>
        <standard-table
          :columns="columns"
          :dataSource="listData"
          rowKey="id"
          :pagination="pagination"
          @change="onChange"
          :loading="loading"
        >
          <div slot="type" slot-scope="record">
            <span>{{ record.record.type | dictFmt }}</span>
          </div>
          <div slot="status" slot-scope="{ record }">
            <span
              class="status_tag"
              :style="{
                background: record.status == '0' ? '#1ab394' : '#ed5565',
              }"
            >
              {{ record.status == "0" ? "正常" : "停用" }}</span
            >
          </div>
          <div slot="operate" slot-scope="record">
            <a @click="handleSendUpdate(record)">修改</a>&nbsp;
            <a @click="handleSendDelete(record)"> 删除 </a>&nbsp;
          </div>
        </standard-table>
      </div>
      <div class="modal" v-show="visible">
        <a-modal
          class="modal2"
          v-model="visible"
          :title="modalTitle"
          @ok="handleOk"
          cancelText="取消"
          okText="保存"
          width="40%"
          :key="key"
        >
          <a-spin :spinning="spinning2">
            <a-form-model ref="sendForm" :model="sendForm" :rules="rules">
              <a-form-model-item
                has-feedback
                label="发货地址"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-show="modalTitle == '添加'"
              >
                <!-- <a-input v-model="receiveForm.name" autocomplete="off" /> -->
                <my-cascader
                  @handleProvinceCity="handleProvinceCity"
                ></my-cascader>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="详细地址"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-show="modalTitle == '添加'"
              >
                <a-textarea
                  v-model="adressSupplement"
                  placeholder="详细地址补充"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                  @blur="handleAdressSupplement"
                />
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="发货地名称"
                prop="name"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-if="modalTitle == '修改'"
              >
                <a-input v-model.trim="sendForm.name" autocomplete="off" />
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="类型"
                prop="type"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-show="modalTitle == '修改'"
              >
                <a-select v-model="sendForm.type">
                  <a-select-option
                    v-for="(item, index) in sendTypeList"
                    :key="index"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="状态"
                prop="satus"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-show="modalTitle == '修改'"
              >
                <a-select v-model="sendStatus">
                  <a-select-option
                    v-for="(item, index) in sendStatusList"
                    :key="index"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </a-spin>
        </a-modal>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import StandardTable from "@/components/StandardTable";
import {
  sendSeach,
  sendSave,
  sendUpdate,
  sendDelete,
} from "@/api/modules/maintainManagement.js";
const columns = [
  {
    title: "发货地名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "类型",
    dataIndex: "type",
    align: "center",
    scopedSlots: { customRender: "type" },
  },
  {
    title: "状态",
    dataIndex: "status",
    align: "center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    width: "200px",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    sorter: (a, b) => {
      return (
        Date.parse(a.createTime.replace(/-/g, "/")) -
        Date.parse(b.createTime.replace(/-/g, "/"))
      );
    },
  },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    scopedSlots: { customRender: "operate" },
  },
];
export default {
  name: "placeofShipmentManagement",
  components: {
    StandardTable,
    MyCascader: () => import("@/components/MyCascader.vue"),
  },
  created() {
    this.search(1);
  },
  data() {
    return {
      spinning: false,
      spinning2: false,
      loading: false,
      listData: null,
      visible: false,
      modalTitle: "",
      sendStatus: "",
      key: 0,
      columns,
      listData: null,
      form: {
        name: "",
        type: 1,
      },
      sendForm: {
        name: "",
        type: 1,
      },
      adressSupplement: "",
      rules: {
        name: [
          { required: true, message: "请输入发货地名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请输入收货地类型", trigger: "blur" },
        ],
      },
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      sendTypeList: [
        { label: "发货地", value: 1 },
        { label: "收货地", value: 2 },
        { label: "品名", value: 3 },
      ],
      sendStatusList: [
        { label: "正常", value: 0 },
        { label: "停用", value: 1 },
      ],
    };
  },
  methods: {
    search(val) {
      let params = {
        pageNum: val,
        pageSize: this.pagination.pageSize,
        name: this.form.name,
        type: this.form.type,
      };
      this.loading = true;
      sendSeach(params).then((res) => {
        if (res.code == "0000") {
          this.listData = res.data.list;
          this.pagination.total = res.data.totalCount;
          this.pagination.current = val;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    reset() {
      for (let index in this.form) {
        if (this.form[index] !== "") {
          this.form[index] = "";
        }
      }
    },
    handleSendSave() {
      this.key++;
      this.modalTitle = "添加";
      this.visible = true;
      this.sendForm.name = "";
      this.adressSupplement = "";
    },
    handleSendUpdate(record) {
      this.key++;
      this.modalTitle = "修改";
      this.sendId = record.record.id;
      this.sendStatus = record.record.status;
      this.sendForm.name = record.record.name;
      this.visible = true;
    },
    handleSendDelete(record) {
      let that = this;
      this.$confirm({
        title: "操作提示",
        content: "是否删除该用户信息？",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let id = record.record.id;
          that.loading = true;
          sendDelete(id).then((res) => {
            if (res.code == "0000") {
              that.search(that.pagination.current);
              that.$message.success(res.msg);
            } else {
              that.$message.warn(res.msg);
            }
            that.loading = false;
          });
        },
      });
    },
    onChange(val) {
      console.log(val);
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
    //添加或者修改提交
    handleOk() {
      let that = this;
      if (this.sendForm.name == "" && this.adressSupplement == "") {
        return this.$message.warn("请至少输入一项地址");
      }
      this.$refs["sendForm"].validate((valid) => {
        if (valid) {
          if (this.modalTitle == "添加") {
            let params = Object.assign(this.sendForm);
            this.spinning2 = true;
            sendSave("", params).then((res) => {
              this.spinning2 = false;
              if (res.code == "0000") {
                that.$message.success(res.msg);
                this.visible = false;
                this.search(1);
              } else {
                that.$message.warn(res.msg);
              }
              this.sendForm.type = 1;
            });
          } else if (this.modalTitle == "修改") {
            let params = Object.assign(this.sendForm);
            params.id = this.sendId;
            params.status = this.sendStatus;
            this.spinning2 = true;
            sendUpdate("", params).then((res) => {
              this.spinning2 = false;
              if (res.code == "0000") {
                that.$message.success(res.msg);
                this.search(this.pagination.current);
                this.visible = false;
              } else {
                that.$message.warn(res.msg);
              }
              this.rsendForm.type = 1;
            });
          }
        } else {
          return false;
        }
      });
    },
    handleProvinceCity(val) {
      this.sendForm.name = val;
    },
    handleAdressSupplement() {
      this.sendForm.name += this.adressSupplement;
    },
  },
};
</script>

<style lang="less" scoped>
.space {
  display: inline-block;
  margin: 0 5px;
}
.tj {
  text-align: left;
  margin-bottom: 10px;
}
.modal2 {
  /deep/ .ant-form-item-label {
    width: 120px !important;
  }
  /deep/ .ant-form-item-control {
    width: 370px !important;
  }
  /deep/ .ant-modal-body{
    min-height: 300px !important;
  }
}
</style>